import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SuperAdminStatusTag } from '../components/common/SuperAdminStatusTag';
import { ACTOR } from '../constants/actors';
import { serializeActor } from 'ui-product-approvals-common/utils/actorKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const buildApproverOption = ({
  approver,
  superAdminUserIds,
  approvedApproverActorKeys,
  requesterActorKey
}) => {
  var _approver$email, _approvedApproverActo;
  const actorKey = serializeActor(approver.actor);
  const displayName = approver.displayName;
  const searchableText = `${displayName} ${(_approver$email = approver.email) !== null && _approver$email !== void 0 ? _approver$email : ''}`;
  const isSuperAdmin = approver.actor.actorType === ACTOR.USER && superAdminUserIds.has(approver.actor.id);
  const isRequester = actorKey === requesterActorKey;
  const isApproved = (_approvedApproverActo = approvedApproverActorKeys === null || approvedApproverActorKeys === void 0 ? void 0 : approvedApproverActorKeys.includes(actorKey)) !== null && _approvedApproverActo !== void 0 ? _approvedApproverActo : false;
  const isDisabled = isApproved || isRequester;
  return {
    text: searchableText,
    buttonText: displayName,
    value: actorKey,
    help: approver.actor.actorType === ACTOR.USER && approver.email ? approver.email : undefined,
    disabled: isDisabled,
    dropdownText: /*#__PURE__*/_jsx(Tooltip, {
      disabled: !isDisabled,
      title: isRequester ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approverSelect.tooltipRequesterDisabled"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approverSelect.tooltipApproverApproved"
      }),
      children: /*#__PURE__*/_jsxs(TFlex, {
        children: [displayName, isSuperAdmin && /*#__PURE__*/_jsx(SuperAdminStatusTag, {})]
      })
    })
  };
};
const GROUP_ORDER = ['AGENT', 'TEAM', 'USER', 'OTHER'];
const groupKeyForActorType = actorType => {
  switch (actorType) {
    case ACTOR.AGENT:
      return 'AGENT';
    case ACTOR.TEAM:
      return 'TEAM';
    case ACTOR.USER:
      return 'USER';
    default:
      return 'OTHER';
  }
};
const groupHeading = key => {
  switch (key) {
    case 'AGENT':
      return I18n.text('productApprovals.approverSelect.group.breezeAgents');
    case 'TEAM':
      return I18n.text('productApprovals.approverSelect.group.teams');
    case 'USER':
      return I18n.text('productApprovals.approverSelect.group.users');
    default:
      return I18n.text('productApprovals.approverSelect.group.other');
  }
};
/**
 * Builds Select options for the given approvers, grouped by actor type
 * (Breeze agents, then teams, then users, then other). Empty groups are
 * omitted. When only a single group has approvers the options are returned
 * flat (no group heading) so a homogeneous list is not needlessly grouped.
 */
export const buildGroupedApproverOptions = ({
  approvers,
  superAdminUserIds,
  approvedApproverActorKeys,
  requesterActorKey
}) => {
  const toOption = approver => buildApproverOption({
    approver,
    superAdminUserIds,
    approvedApproverActorKeys,
    requesterActorKey
  });
  const nonEmptyGroups = GROUP_ORDER.map(key => ({
    key,
    approvers: approvers.filter(approver => groupKeyForActorType(approver.actor.actorType) === key)
  })).filter(group => group.approvers.length > 0);
  if (nonEmptyGroups.length <= 1) {
    return approvers.map(toOption);
  }
  return nonEmptyGroups.map(group => ({
    text: groupHeading(group.key),
    options: group.approvers.map(toOption)
  }));
};